export async function filterTree(nodes, rules = []) {
  const result = [];

  for (const node of nodes) {
    let keep = true;

    for (const rule of rules) {
      const passed = await rule(node);
      if (!passed) {
        keep = false;
        break;
      }
    }

    if (!keep) continue;

    const filteredItems = await filterTree(node.items ?? [], rules);
    result.push({
      ...node,
      items: filteredItems
    });
  }

  return result;
}
